import PerformanceProfilerFactory from "../../../../utils/performanceProfiler/performanceProfilerFactory";
import { MeasureName } from "../../../../utils/performanceProfiler/measureName";
import type { IPerformanceProfiler } from "../../../../utils/performanceProfiler/performanceProfilerInterface";

let activeProfiler: IPerformanceProfiler | null = null;

export function startBasicLoginProfiler(): void {
    activeProfiler?.cancel();
    activeProfiler = PerformanceProfilerFactory.getInstance(MeasureName.BasicLogin);
    activeProfiler.start();
}

export function endBasicLoginProfiler(): void {
    activeProfiler?.end();
    activeProfiler = null;
}

export function cancelBasicLoginProfiler(): void {
    activeProfiler?.cancel();
    activeProfiler = null;
}
